/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const createItemObjectiveRequestSchema = z.object({
  itemId: z.int(),
  objectiveId: z.int(),
});
